export default from './VideoMessage';



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/VideoMessage/index.js